import React from "react";
import { Box } from "@mui/material";
import { CardShell, OutlineButton, Spinner, StatusChip, T, ToolBadge } from "./chrome";
import { jiraConnectActions } from "./flowStore";
import { useJiraConnectFlow } from "./useJiraConnectFlow";

const STAGE_ORDER = ["idle", "authorizing", "verifying", "selecting_project", "ready_to_sync", "importing", "synced"];

export default function StatusCard(): React.ReactElement {
    const flow = useJiraConnectFlow();
    const errored = flow.error?.stage === "verifying";
    const verified = STAGE_ORDER.indexOf(flow.stage) > STAGE_ORDER.indexOf("verifying");

    return (
        <CardShell testId="jc-status">
            <Box sx={{ padding: "11px 14px", display: "flex", alignItems: "center", gap: "10px" }}>
                <ToolBadge name="integration_status" />
                {errored ? (
                    <>
                        <Box sx={{ fontSize: "12px", color: T.fg3, flex: 1 }}>{flow.error?.message}</Box>
                        <OutlineButton label="Retry" onClick={jiraConnectActions.retry} />
                        <StatusChip tone="error" label="Failed" />
                    </>
                ) : verified ? (
                    <>
                        <Box sx={{ fontSize: "12px", color: T.fg3 }}>Connection verified</Box>
                        <StatusChip tone="success" label="Connected" />
                    </>
                ) : flow.stage === "verifying" ? (
                    <>
                        <Box sx={{ fontSize: "12px", color: T.fg3 }}>Verifying connection…</Box>
                        <Box sx={{ marginLeft: "auto" }}><Spinner size={13} /></Box>
                    </>
                ) : (
                    <>
                        <Box sx={{ fontSize: "12px", color: T.fg3 }}>Waiting for authorization</Box>
                        <StatusChip tone="neutral" label="Pending" />
                    </>
                )}
            </Box>
        </CardShell>
    );
}
